import { render, staticRenderFns } from "./ExamTakerAnswerTable.vue?vue&type=template&id=6298a561&scoped=true"
import script from "./ExamTakerAnswerTable.vue?vue&type=script&lang=js"
export * from "./ExamTakerAnswerTable.vue?vue&type=script&lang=js"
import style0 from "./ExamTakerAnswerTable.vue?vue&type=style&index=0&id=6298a561&prod&lang=scss&scoped=true"
import style1 from "./ExamTakerAnswerTable.vue?vue&type=style&index=1&id=6298a561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298a561",
  null
  
)

export default component.exports